import { defaultHttpClient } from '../../httpClient';
import type { GetMainTabsResponse } from './types';

export const getMainTabs = () => {
  return defaultHttpClient
    .request<GetMainTabsResponse>({
      method: 'GET',
      url: '/api/v2/main/tabs/',
    })
    .then(result => result.data);
};
